import { ActionType } from "../action-types";
import { Action } from "../actions";
import { ContactDto } from "../../dto/contact";

export interface CustomerSearchState {
  item: ContactDto | null;
  isLoading: boolean;
  query: string;
}

const initialState: CustomerSearchState = {
  item: null,
  isLoading: false,
  query: "",
};

export const customerSearchReducer = (
  state: CustomerSearchState = initialState,
  action: Action
): CustomerSearchState => {
  switch (action.type) {
    case ActionType.SET_CUSTOMER_SEARCH_LOADING:
      return { ...state, isLoading: action.payload as boolean };

    case ActionType.SET_CUSTOMER_SEARCH_RESULTS: {
      const { query, item } = action.payload as {
        query: string;
        item: ContactDto;
      };
      return { ...state, query, item };
    }

    default:
      return state;
  }
};
